import React, { useState } from 'react';
import { TableCell } from '@mui/material';
import ActionButton from '@components/Button/ActionButton';
import useSx from './sx';

const ReferrerColumn = ({ onOrderChange }: { onOrderChange: (orderChange: string) => void }) => {
  const sx = useSx();
  const [order, setOrder] = useState<string>('ASC');
  const ariaSort = order === 'ASC' ? 'ascending' : 'descending';
  const onCellClick = () => {
    const newOrder = order === 'ASC' ? 'DESC' : 'ASC';
    setOrder(newOrder);
    onOrderChange(newOrder);
  };

  return (
    <TableCell sx={sx.root} onClick={onCellClick} aria-sort={ariaSort}>
      <ActionButton className="button" tabIndex={0} text="Médico Referente" />
    </TableCell>
  );
};

export default ReferrerColumn;
